import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalHeader,
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem
} from "reactstrap";
import BaseUrl from "../../base-api";
import { toast } from "react-toastify";
import "./RegistrationDetails.css";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faEdit, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

export default function () {
  const navigate = useNavigate();
  const [array, setArray] = useState({
    applicantName: "",
    applicationStatus: "",
    course: "",
    mobileNumber: "",
  });

  const [mobileNumber, setMobileNumber] = useState('');
  const imgRef = useRef(null);
  const [courses, setCourses] = useState([]);
  const [infoData, setInfoData] = useState({});
  const [alreadySubmitted, setAlreadySubmitted] = useState(true);
  const [resubmission, setResumbission] = useState(false);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [boards, setBoards] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [ndocuments, setNdocuments] = useState([]);
  const [isemployee, setIsemployee] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const containerRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [payment, setPayment] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [imageBlob, setImageBlob] = useState(null);
  const [modal, setModal] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const [selectedParentCourse, setSelectedParentCourse] = useState({ key: "", value: "" });
  const parentCourseOther = {
    courseKey: "other",
    courseName: "Career Oriented Courses",
    isParent: true,
  };
  const [selectedOtherCourse, setSelectedOtherCourse] = useState([]);
  const [selectedParentCourseBack, setSelectedParentCourseBack] = useState([]);
  const [selectedOtherCourseBack, setSelectedOtherCourseBack] = useState([]);
  const detectMimeType = (bytes) => {
    const hex = bytes.slice(0, 4).map(b => b.toString(16).padStart(2, '0')).join('');

    switch (hex) {
      case '25504446': return { mime: 'application/pdf', ext: 'pdf' };
      case '89504e47': return { mime: 'image/png', ext: 'png' };
      case 'ffd8ffe0':
      case 'ffd8ffe1':
      case 'ffd8ffe2': return { mime: 'image/jpeg', ext: 'jpg' };
      default: return { mime: 'application/octet-stream', ext: 'bin' };
    }
  };

  const [regDetails, setRegDetails] = useState({

    employee: "",
    board: "",
    // schoolName: '',
    mobileNumber: "",
    schoolYear: "",
    schoolMonth: "",
    rollNumber: "",
    country: "",
    state: "",
    district: "",
    address: "",
    pincode: "",
    marksObtained: "",
    totalMarks: "",
    appStatus: "",
    docs: []
  });

const viewLabelForAbbr = (abbr = "") => {
  switch (abbr.toLowerCase()) {
    case "photo": return "Photo";
    case "sign": return "Signature";
    case "12th":
    case "marksheet": return "Marksheet";
    case "uni": return "University Document";
    default: return "Document";
  }
};




  useEffect(() => {
    if (imageBlob && imgRef.current) {
      const renderImage = async () => {
        try {
          const url = URL.createObjectURL(imageBlob);
          imgRef.current.src = url;
        } catch (error) {
          toast.error('Error rendering image');
          console.error(error);
        }
      };
      renderImage();
    }
  }, [imageBlob]);
  // const [marksdata, setMarksdata] = useState({
  //   totalMarks: 0,
  //   marksObtained: 0
  // });
  // const marksChange = (e) => {
  //   const { name, value } = e.target;

  //   setMarksdata({
  //     ...marksdata,
  //     [name]: parseInt(value)
  //   });
  // };



  const validateMarks = () =>
    regDetails.marksObtained && regDetails.totalMarks
      ? Number(regDetails.marksObtained) <= Number(regDetails.totalMarks)
      : true;
  const handleDataView = (status, data) => {
    if (status === null) {
      setAlreadySubmitted(false);
      setIsEdit(true);
    }
    else if (status === 'Rejected') {
      setRegDetails((prev) => ({
        ...prev,
        course: data.course,
        employee: data.employee,
        board: data.board,
        schoolYear: data.schoolYear,
        schoolMonth: data.schoolMonth,
        rollNumber: data.rollNumber,
        country: data.country,
        state: data.state,
        district: data.district,
        address: data.address,
        pincode: data.pincode,
        marksObtained: data.marksObtained,
        totalMarks: data.totalMarks,
        docs: data.documentsDto,
        appStatus: data.status
      }));

      setSelectedParentCourseBack(data.parentCourse)
      setSelectedOtherCourseBack(data.otherCourses)
      fetchStates(data.country);
      fetchDistricts(data.state);
      setMobileNumber(data.mobileNumber);
      setInfoData(data);
      setIsEdit(true);
      processDocuments(data.documentsDto)
    } else {
      setInfoData(data);
    }
  }
  const base64ToUint8Array = (base64) => {
    const binaryStr = atob(base64);
    const len = binaryStr.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryStr.charCodeAt(i);
    }
    return bytes;
  };
  const processDocuments = async (documents) => {
    const docs = await Promise.all(
      documents?.map(async (doc) => {
        const base64 = doc.data.split(',').pop();
        const uint8Array = base64ToUint8Array(base64);
        const fileTypeResult = detectMimeType(Array.from(uint8Array));
        return {
          "docName": doc.docName, "multipartFile": new File([uint8Array], "doc." + (fileTypeResult?.ext || 'bin'), {
            type: fileTypeResult?.mime || 'application/octet-stream'
          },
          )
        };
      }) || []
    );
    setNdocuments(docs);
  };
  const handleEdit = (status) => {
    if (status == true) {
      setIsEdit(true);
      setRegDetails((prev) => ({
        ...prev,
        course: infoData.course,
        employee: infoData.employee,
        board: infoData.board,
        schoolYear: infoData.schoolYear,
        schoolMonth: infoData.schoolMonth,
        rollNumber: infoData.rollNumber,
        country: infoData.country,
        state: infoData.state,
        district: infoData.district,
        address: infoData.address,
        pincode: infoData.pincode,
        marksObtained: infoData.marksObtained,
        totalMarks: infoData.totalMarks,
        docs: infoData.documentsDto,
        appStatus: infoData.status
      }))
      setSelectedParentCourse(courses.find(d => d.courseName == infoData.parentCourse))
      let otherCourses = [];
      infoData.otherCourses?.forEach(c => {
        let obj = courses?.find(d => d.courseName == c);
        otherCourses.push({
          value: obj?.courseKey,
          label: obj.courseName
        })
      })
      setSelectedOtherCourse(otherCourses)
      fetchStates(infoData.country);
      fetchDistricts(infoData.state);
      setMobileNumber(infoData.mobileNumber);
      processDocuments(infoData.documentsDto)
    } else {
      setIsEdit(false)
    }
  }
  useEffect(() => {
    axios
      .get(`${BaseUrl}/reg/fetchApplicationStatus`, {
        headers: { Authorization: localStorage.getItem("$3ingT0k3n") },
      })
      .then(function (response) {
        handleDataView(response.data.status, response.data);
      })
      .catch(function (error) {
        toast.error(error);
      });
    axios
      .get(`${BaseUrl}/reg/registrationDto`)
      .then(function (response) {
        setCourses([
          ...response.data.courses,
          parentCourseOther
        ]);
        setYear(response.data.year);
        setMonth(response.data.month);
        setCountries(response.data.countries);
        setBoards(response.data.boards);
        setDocuments(response.data.documents);
      })
      .catch(function (error) {
        toast.error(error);
      });
  }, []);
  useEffect(() => {
    if (regDetails.employee) hidedoc();
  }, [regDetails.employee]);
  const fetchStates = (val) => {
    if (val != "" && val != undefined) {
      axios
        .get(`${BaseUrl}/reg/fetchStates?country=` + val, {
          headers: { Authorization: localStorage.getItem("$3ingT0k3n") },
        })
        .then(function (response) {
          setStates(response.data);
        });
    } else {
      setStates([]);
    }
  };
  const fetchDistricts = (e) => {
    if (e != "" && e != undefined) {
      axios
        .get(`${BaseUrl}/reg/fetchDistricts?state=` + e, {
          headers: { Authorization: localStorage.getItem("$3ingT0k3n") },
        })
        .then(function (response) {
          setDistricts(response.data);
        });
    } else {
      setDistricts([]);
    }
  };
  const handleChange = (e) => {
    let errorMessage = "";

    const value = e.target.value;
    if (e.target.classList != undefined)
      e.target.classList.remove("highlighted-input");
    // e.target.blur();
    if (e.target.type != undefined) {
      switch (e.target.type) {
        case "document":
          const fileType = e.target.value.type;
          if (
            ![
              "image/jpeg", "image/jpg", "image/png"
            ].includes(fileType)
          ) {
            toast.error("Only JPG, JPEG, or PNG files are allowed for document uploads.");
            document.getElementById(e.target.id).value = null;
            return;
          }
          else if (e.target.value.size > 1024 * 1024) {
            toast.error("File size should be less than 1MB");
            document.getElementById(e.target.id).value = null;
            return;
          }
          else if
            (
            e.target.value.size > 1024 * 1024) { }
          let doclist = ndocuments;
          doclist = doclist.filter((f) => f.docName !== e.target.name);
          doclist.push({
            docName: e.target.name,
            multipartFile: e.target.value,
          });
          setNdocuments(doclist);
          break;
        default:
          switch (e.target.name) {
            case "marksheet":
              if (value && !["image/jpeg", "image/jpg"].includes(value.type)) {
                errorMessage = "Only JPG/JPEG files are allowed";
              } else if (value && value.size > 1024 * 1024) {
                errorMessage = "File size should be less than 1MB";
              }
              break;
            case "uniCert":
              if (value && !["image/jpeg", "image/jpg"].includes(value.type)) {
                errorMessage = "Only JPG/JPEG files are allowed";
              } else if (value && value.size > 1024 * 1024) {
                errorMessage = "File size should be less than 1MB";
              }
              break;
            case "photograph":
              if (value && !["image/jpeg", "image/jpg"].includes(value.type)) {
                errorMessage = "Only JPG/JPEG files are allowed";
              } else if (value && value.size > 1024 * 1024) {
                errorMessage = "File size should be less than 1MB";
              }
              break;
            case "signature":
              if (value && !["image/jpeg", "image/jpg"].includes(value.type)) {
                errorMessage = "Only JPG/JPEG files are allowed";
              } else if (value && value.size > 1024 * 1024) {
                errorMessage = "File size should be less than 1MB";
              }
              break;
            case "marksObtained":
              if (!/^\d*$/.test(value)) {
                errorMessage = "Only numbers allowed";
              }
              break;
            case "totalMarks":
              if (!/^\d*$/.test(value)) {
                errorMessage = "Only numbers allowed";
              }
              break;
            case "pincode":
              if (!/^\d*$/.test(value)) {
                errorMessage = "Only numbers allowed";
              }
              break;
            case "rollNumber":
              if (!/^\d*$/.test(value)) {
                errorMessage = "Only numbers allowed";
              }
              break;

            default:
              break;
          }


          break;
      }
    }
    if (e.target.name === "employee" && e.target.value === "No") {
      setNdocuments([]);
    }
    if (errorMessage.length > 0) {
      e.target.blur();
      e.target.classList.add("highlighted-input");
      toast.error(errorMessage, { position: "top-center" });
    }
    setRegDetails((prevData) => ({
      ...prevData,
      [e.target.name]: value,
    }));
  };
  /******  cb7a92be-cf46-4ca2-af18-4c9351088960  *******/

  const postDetails = async () => {
    try {
      const formData = new FormData();

      for (const key in regDetails) {
        if (key !== "documentsDto" && key !== "docs" && key !== "appStatus") {
          formData.append(key, regDetails[key]);
        }
      }

      formData.append("parentCourse", selectedParentCourse?.courseKey);

      selectedOtherCourse.forEach((course, index) => {
        formData.append(`otherCourses[${index}]`, course.value);
      });

      ndocuments.forEach((doc, index) => {
        formData.append(`documentsDto[${index}].docName`, doc.docName);
        formData.append(
          `documentsDto[${index}].multipartFile`,
          doc.multipartFile
        );
      });
      const response = await axios.post(
        `${BaseUrl}/reg/saveRegistrationDetails`,
        formData,
        {
          headers: {
            Authorization: localStorage.getItem("$3ingT0k3n"),
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status == 200) {
        toast.success(response.data.message, {
          className: "toast-large",
          position: "top-center",
        }); setLoadingMessage("Waiting for payment confirmation....");
        setPayment(true);
        navigate("/SideBar/my-courses");
        // if(resubmission){
        //   navigate("/SideBar/my-courses");
        // } else{
        //   submitPaymentForm(response.data);
        // }

      } else toast.error(response.data.message, { position: "top-center" });
    } catch (error) {
      toast.error(error.response.data.message, { position: "top-center" });
    }
  };
  const validateFields = () => {
    let validRequest = true;
    if (!validateMarks()) {
      validRequest = false;
      toast.error("Marks Obtained cannot be greater than Total Marks.", { position: "top-center" });
    }
    let doclist = documents?.map((d) => d.docName);
    let regD = Object.keys(regDetails).filter(
      (f) => f !== "documentsDto" && !doclist.includes(f) && f !== "docs" && f !== "appStatus" && f !== "mobileNumber"
    );

    regD.forEach((reg) => {
      const val = regDetails[reg];
      // console.log(reg + "--> " + val + " element--> ");
      if (val !== null && val !== 0 && val !== "")
        document.getElementById(reg)?.classList.remove("highlighted-input");
      else {
        document.getElementById(reg)?.classList.add("highlighted-input");
        window.scroll(0, 0);
        validRequest = false;
      }
    });



    if (regDetails.employee.toLowerCase() == "yes") {
      documents.forEach((dMaster) => {
        ndocuments.forEach((dUpd) => {
          if (dMaster.docName === dUpd.docName) {
          }
        });
      });
      if (ndocuments.length !== documents.length) {
        toast.error("Kindly fill all the required fields");
        window.scroll(0, 0);
        validRequest = false;
      }
    } else {
      if (!(ndocuments.length == documents.length - 1)) {
        toast.error("Kindly fill all the required fields");

        window.scroll(0, 0);
        validRequest = false;
      }
    }

    if (validRequest) postDetails();
  };

  function hidedoc() {
    const markSheetLabel = document.getElementsByName("marksheetLabel")[3];
    const markSheetInput = document.getElementById(`documentsDto.marksheet3`);
    const markSheetInput0 = document.getElementById(`documentsDto.marksheet0`);
    const markSheetInput1 = document.getElementById(`documentsDto.marksheet1`);
    const markSheetInput2 = document.getElementById(`documentsDto.marksheet2`);

    if (regDetails.employee === "No") {
      if (markSheetInput) {
        markSheetInput.value = "";
        markSheetInput0.value = "";
        markSheetInput1.value = "";
        markSheetInput2.value = "";
      }

      if (markSheetLabel) {
        markSheetLabel.style.display = "none";
      }
    } else {
      if (markSheetLabel) {
        markSheetLabel.style.display = "block";
      }
    }
  }

  const toggle = () => setModal(!modal);
  const loadProfile = async (mob, doc) => {
    try {

      const formData = { mobileNumber: mob, abbr: doc };
      const response = await axios.post(
        `${BaseUrl}/admin/viewDocument`,
        formData,
        {
          headers: { Authorization: localStorage.getItem('$3ingT0k3n') },
          responseType: 'arraybuffer',
        }
      );
      let contentType = response.headers['content-type'];
      if (!contentType) {
        // Fallback to checking the image data
        const uint = new Uint8Array(response.data);

        contentType = getImageType(uint);
      }

      // Create Blob based on image type
      const imageBlob = new Blob([response.data], { type: contentType });
      setImageBlob(imageBlob); // Setting Blob to state

      //   const applicantData = allData.find((c) => c.mobileNumber === mob);
      //   if (applicantData) {
      setArray({
        //   applicantName: applicantData.applicantName,
        //   applicationStatus: applicantData.applicationStatus,
        //   course: applicantData.course,
        mobileNumber: mob,
      });
      //   }
    } catch (error) {
      toast.error(error.message);
      console.error(error);
    }
  };

  const getImageType = (uint) => {
    const header = uint[0].toString(16) + uint[1].toString(16);
    switch (header) {
      case '8950': // PNG header
        return 'image/png';
      case 'ffd8': // JPEG header
        return 'image/jpeg';
      default:
        throw new Error('Unsupported image type');
    }
  };

  const [mandatoryCourse, setMandatoryCourse] = useState(null);
  const [minValue, setMinValue] = useState(0); // State for min value
  const [maxValue, setMaxValue] = useState(10);
  const [showMaxValueMessage, setShowMaxValueMessage] = useState(false);


  const handleParentCourseChange = (e) => {
    const selectedParent = e.target.value;
    setSelectedParentCourse(courses.find(d => d?.courseKey == selectedParent));
    setSelectedOtherCourse([]);

    if (selectedParent) {

      const selectedCourse = courses.find(course => course?.courseKey === selectedParent);
      setMandatoryCourse(selectedCourse?.mandatoryCourse || null);
      setMinValue(selectedCourse?.minValue);
      setMaxValue(selectedCourse?.maxValue);
    } else {
      setMandatoryCourse(null);
      setMinValue(null);
      setMaxValue(null);
    }
  };


  const handleOtherCourseChange = (selectedOptions) => {
    if (selectedOptions.length <= maxValue) {
      setSelectedOtherCourse(selectedOptions || []);
    }
  };



  const handleSelectedOtherCourses = (selectedOption) => {
    // Ensure the state only holds one selected value
    if (selectedOption.length > 1) {
      setSelectedOtherCourse([selectedOption[selectedOption.length - 1]]);
    } else {
      setSelectedOtherCourse(selectedOption);  // Single course selected
    }
  };
  const [nonParentCourses, setNonParentCourses] = useState([]);
  const [mandatoryCourses, setMandatoryCourses] = useState([]);
  useEffect(() => {
    if (courses) {
      setNonParentCourses(courses.filter(course => !course.isParent))
      setMandatoryCourses(courses.filter(course => course.mandatoryCourse === true))
    }
  }, [courses])



  return (
    <Container
      className="border round py-2"
      style={{
        backgroundColor: "#f6f5f591",
        boxShadow:
          "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        borderRadius: "9px",
      }}
    >
      <div className="d-flex">
        <h2 style={{ color: "#000dd3" }}>Admission Form  </h2>
        {alreadySubmitted && infoData?.status === 'Registered' && !isEdit && <button className="btn btn-info" style={{ marginLeft: "auto", color: "white" }} onClick={() => handleEdit(true)}>
          Edit<FontAwesomeIcon
            icon={faEdit}
            className="ms-1"
          ></FontAwesomeIcon>
        </button>}
        {alreadySubmitted && isEdit && regDetails?.appStatus !== 'Rejected' && <button className="btn btn-danger" style={{ marginLeft: "auto", color: "white" }} onClick={() => handleEdit(false)}>
          Cancel<FontAwesomeIcon
            icon={faExclamationCircle}
            className="ms-1"
          ></FontAwesomeIcon>
        </button>}
      </div>
      {alreadySubmitted && (
        <>


          {!isEdit && <>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <td style={{ width: "20%", fontWeight: "bold", border: "1px solid #ddd" }}>Selected Course</td>
                  <td style={{ width: "50%", fontWeight: "bold", border: "1px solid #ddd" }}>Sub-Category</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {/* Parent Course */}
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>{infoData.parentCourse}</td>

                  {/* Conditionally render the <td> for otherCourses */}
                  {Array.isArray(infoData.otherCourses) && infoData.otherCourses.length > 0 ? (
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                        {infoData.otherCourses?.map((course, index) => (
                          <li key={index} style={{ padding: "4px 0" }}>
                            {course}
                          </li>
                        ))}
                      </ul>
                    </td>
                  ) : null}
                </tr>
              </tbody>
            </table>
            <h5 style={{ color: "#000dd3" }}>Details of 12th Standard or Equivalent</h5>
            <Table
              striped
              style={{
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              }}
            >
              <thead>
                <tr>
                  <td style={{ width: "30%" }}>Board</td>
                  <td style={{ width: "15%" }}>Passing Year</td>
                  <td style={{ width: "15%" }}>Passing Month</td>
                  <td style={{ width: "20%" }}>12th Roll Number</td>
                  <td style={{ width: "20%" }}>Marks Obtained</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{infoData.board}</td>
                  <td>{infoData.schoolYear}</td>
                  <td>{infoData.schoolMonth}</td>
                  <td>{infoData.rollNumber}</td>
                  <td>
                    {infoData.marksObtained} out of {infoData.totalMarks}
                  </td>
                </tr>
              </tbody>
            </Table>
            <h5 style={{ color: "#000dd3", marginTop: "5%" }}>Address Details</h5>
            <table
              className="mb-3"
              style={{
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              }}
            >
              <tbody>
                <tr>
                  <td style={{ width: "100%" }} colSpan={3}>
                    <b>Address:</b> {infoData.address}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "33.33%" }}>
                    <b>Country:</b> {infoData.country}
                  </td>
                  <td style={{ width: "33.33%" }}>
                    <b>State:</b> {infoData.state}
                  </td>
                  <td style={{ width: "33.33%" }}>
                    <b>District:</b> {infoData.district}
                  </td>
                </tr>
              </tbody>
            </table>
            <h5 style={{ color: "#000dd3", marginTop: "5%" }}>Other Details</h5>
            <table
              style={{
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              }}
            >
              <tbody>
                <tr>
                  <td style={{ width: "50%" }}>
                    GJU University Employee/ Ward/ Spouse
                  </td>
                  <td>{infoData.employee}</td>
                </tr>
              </tbody>
            </table>
            <h5 style={{ color: "#000dd3", marginTop: "5%" }}>
              Document Details
            </h5>
            <Table
              striped
              style={{
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              }}
            >
              <thead>
                <tr>
                  <td>S. No.</td>
                  <td>Document Name</td>
                  <td></td>
                </tr>
              </thead>
              <tbody>


                {infoData.documentsDto != undefined &&

                  infoData.documentsDto?.map((doc, index) => (
                    <tr>
                      <td style={{ width: "10%" }}>{index + 1}</td>
                      <td style={{ width: "70%" }}>{doc.docName}</td>
                      <td style={{ width: "20%" }}>
                        <a
                          onClick={() => {

                            toggle();
                            loadProfile(infoData.mobileNumber, doc.abbr);
                          }}
                          style={{ textDecoration: "underline", cursor: "pointer" }}
                        > View Uploaded {viewLabelForAbbr(doc.abbr)} </a>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table></>}
        </>
      )}
      {(!alreadySubmitted || isEdit) && (
        <>
          {" "}
          <Form style={{ color: "grey" }}>


            <h5 style={{ color: "#413c58" }}>Course Selection</h5>
            <h6 style={{ color: "#0f0f0f" }}>
              Select the Course in which you want to apply
            </h6>
            <Row>

              {/* Parent Course Dropdown */}
              <Col md={6} xs={12}>
                <FormGroup className="m-2">
                  <Label for="parentCourse">Select  Course</Label>
                  <Input
                    type="select"
                    name="parentCourse"
                    id="parentCourse"
                    value={selectedParentCourse?.courseKey}
                    onChange={handleParentCourseChange}
                    required
                  >
                    <option value="">Select  Course</option>
                    {courses.filter(course => course.isParent)?.map((course) => (
                      <option key={course?.courseKey} value={course?.courseKey}
                      // selected={selectedParentCourse && (course?.courseKey == selectedParentCourse || course.courseName == parentCourseOther.courseName)}
                      >
                        {course.courseName}
                      </option>
                    ))}
                    {/* <option value="other">parentCourseOther/option> */}
                  </Input>
                </FormGroup>
              </Col>

              {/* Show non-parent courses when a parent course is selected */}
              {(selectedParentCourse?.courseKey && selectedParentCourse?.courseKey !== 'other') && (
                <Col md={6} xs={12}>
                  <FormGroup className="m-2">
                    <Label for="otherCourse">Select Course under your Selection.</Label>
                    <Select
                      isMulti
                      name="otherCourse"
                      id="otherCourse"
                      required
                      options={[
                        ...(mandatoryCourses.length > 0 && !selectedOtherCourse.some(course => course.value === mandatoryCourses[0]?.courseKey)
                          ? [{ value: mandatoryCourses[0]?.courseKey, label: mandatoryCourses[0].courseName }]
                          : []),

                        ...nonParentCourses?.filter(course =>
                          !selectedOtherCourse.some(selectedCourse => selectedCourse.value === course?.courseKey) &&
                          course?.courseKey !== 'socialMediaMarketing' &&
                          course?.courseKey !== 'digitalFreelance'
                        ).map(course => ({
                          value: course?.courseKey,
                          label: course.courseName
                        }))
                      ]}


                      //   ...nonParentCourses?.map(course => ({
                      //     value: course?.courseKey,
                      //     label: course.courseName
                      //   }))
                      // ]}
                      value={[
                        ...(mandatoryCourses.length > 0 && !selectedOtherCourse.some(course => course.value === mandatoryCourses[0]?.courseKey)
                          ? [{ value: mandatoryCourses[0]?.courseKey, label: mandatoryCourses[0].courseName }]
                          : []),
                        ...selectedOtherCourse
                      ]}
                      onChange={handleOtherCourseChange}

                      isValidNewOption={(inputValue) => inputValue && inputValue.length >= minValue}
                      maxSelection={maxValue}
                      noOptionsMessage="No more options"
                    />


                    {mandatoryCourses.length > 0 && !selectedOtherCourse.some(course => course.value === mandatoryCourses[0]?.courseKey) && (
                      <div className="text-info">
                        <p><strong></strong> {mandatoryCourses[0].courseName} is mandatory under your selected course. Kindly select the additional course/courses.</p>
                      </div>
                    )}
                    {selectedOtherCourse.length < minValue && (
                      <span className="text-danger">For the selected course, select atleast {minValue} course(s)</span>
                    )}
                    {selectedOtherCourse.length > maxValue && (
                      <span className="text-danger">You have already selected the {maxValue} courses.</span>
                    )}
                    {selectedOtherCourse.length === maxValue && (
                      <span className="text-danger">You have already selected the {maxValue} courses.</span>
                    )}

                  </FormGroup>
                </Col>
              )}

              {selectedParentCourse?.courseKey === 'other' && (
                <Col md={6} xs={12}>
                  <FormGroup className="m-2">
                    <Label for="otherCourse">Select Course under your selection</Label>
                    <Select
                      isMulti
                      name="otherCourse"
                      id="otherCourse"
                      options={nonParentCourses?.map(course => ({
                        value: course?.courseKey,
                        label: course.courseName

                      }))}
                      required
                      value={selectedOtherCourse}
                      onChange={handleSelectedOtherCourses}
                      closeMenuOnSelect={true}


                    />
                    {selectedOtherCourse && selectedOtherCourse.length > 1 && (
                      <small className="text-danger">You can only select one course at a time.</small>
                    )}
                  </FormGroup>
                </Col>
              )}

            </Row>
            <hr></hr>
            <h5 style={{ color: "#413c58" }}>
              Details of 12th Standard or Equivalent
            </h5>
            <h6 style={{ color: "#0f0f0f" }}>
              Fill your Details of 12th Standard or Equivalent. Ensure that these details should be same on the uploaded 12th document.
            </h6>
            <Row>
              <Col md={6} xs={12}>
                <FormGroup className="m-2">
                  <Label for="board">Select Board</Label>
                  <Input
                    type="select"
                    name="board"
                    id="board"
                    onChange={handleChange}
                    disabled={!isEdit}
                  >
                    <option value="">Select Board</option>
                    {boards?.map((q) => (
                      <option key={q} value={q} selected={q == regDetails.board}>
                        {q}
                      </option>
                    ))}{" "}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className="m-2">
                  <Label for="schoolYear">Passing Year</Label>
                  <Input
                    type="select"
                    name="schoolYear"
                    id="schoolYear"
                    onChange={handleChange}
                    disabled={!isEdit}
                  >

                    <option value="">Year </option>
                    {year?.map((q) => (
                      <option key={q} value={q} selected={q == regDetails.schoolYear} >
                        {q}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>

              <Col md={3}>
                <FormGroup className="m-2">
                  <Label for="schoolMonth">Passing Month</Label>
                  <Input
                    type="select"
                    name="schoolMonth"
                    id="schoolMonth"
                    onChange={handleChange}
                    disabled={!isEdit}
                  >
                    <option value="">Month </option>
                    {month?.map((q) => (
                      <option key={q} value={q} selected={q == regDetails.schoolMonth}>
                        {q}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="rollNumber">
                    12<sup>th</sup> Roll Number{" "}
                  </Label>
                  <Input
                    id="rollNumber"
                    name="rollNumber"
                    placeholder="Enter Roll number"
                    type="number"
                    min={0}
                    value={regDetails.rollNumber}
                    onChange={handleChange}
                    disabled={!isEdit}
                  />
                </FormGroup>
              </Col>

              <Col md={3}>
                <FormGroup className="m-2">
                  <Label for="totalMarks">Total Marks </Label>
                  <Input
                    id="totalMarks"
                    name="totalMarks"
                    placeholder="Enter your Total Marks"
                    type="number"
                    min={0}
                    value={regDetails.totalMarks}
                    disabled={!isEdit}
                    onChange={(e) => {
                      // marksChange(e);
                      handleChange(e);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className="m-2">
                  <Label for="marksObtained">Marks Obtained </Label>
                  <Input
                    id="marksObtained"
                    name="marksObtained"
                    placeholder="Enter Marks Obtained"
                    type="number"
                    min={0}
                    value={regDetails.marksObtained}
                    disabled={!isEdit}
                    onChange={(e) => {
                      // marksChange(e);
                      handleChange(e);
                    }}
                    invalid={!validateMarks()}
                  />
                  {!validateMarks() && (
                    <div className="invalid-feedback">Marks Obtained cannot be greater than Total Marks.</div>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <hr></hr>
            <Row>
              <h5 style={{ color: "#413c58" }}>Address Details</h5>
              <h6 style={{ color: "#0f0f0f" }}>
                Fill your address details. Please ensure that the same address
                will be used for delivering the certificate.
              </h6>

              <Col md={4}>
                <FormGroup className="m-2">
                  <Label for="country">Select Country</Label>
                  <Input
                    type="select"
                    name="country"
                    id="country"
                    disabled={!isEdit}
                    onChange={(e) => {
                      handleChange(e);
                      fetchStates(e.target.value);
                    }}
                  >
                    <option value="">Select Country</option>
                    {countries?.map((q) => (
                      <option key={q} value={q} selected={q == regDetails.country}>
                        {q}
                      </option>
                    ))}{" "}
                  </Input>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup className="m-2">
                  <Label for="state">Select State</Label>
                  <Input
                    type="select"
                    name="state"
                    id="state"
                    disabled={!isEdit}
                    onChange={(e) => {
                      handleChange(e);
                      fetchDistricts(e.target.value);
                    }}
                  >
                    <option value="">Select State</option>
                    {states?.map((q) => (
                      <option key={q} value={q} selected={q == regDetails.state}>
                        {q}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="m-2">
                  <Label for="district">Select District</Label>
                  <Input
                    type="select"
                    name="district"
                    id="district"
                    disabled={!isEdit}
                    onChange={handleChange}
                  >
                    <option value="">Select District</option>
                    {districts?.map((q) => (
                      <option key={q} value={q} selected={q == regDetails.district}>
                        {q}
                      </option>
                    ))}{" "}
                  </Input>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="address">Full Address </Label>
                  <Input
                    id="address"
                    name="address"
                    placeholder="Enter Address"
                    type="text"
                    onChange={handleChange}
                    value={regDetails.address}
                    disabled={!isEdit}
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="pincode">Pincode </Label>
                  <Input
                    id="pincode"
                    name="pincode"
                    placeholder="Enter Pincode"
                    type="number"
                    min={0}
                    onChange={handleChange}
                    value={regDetails.pincode}
                    disabled={!isEdit}
                  />
                </FormGroup>
              </Col>
            </Row>
            <hr></hr>
            <h5>Other Details</h5>
            <h6 style={{ color: "#0f0f0f" }}>
              Select Yes in case you are the University Employee of GJUS&T,
              Hisar or the ward/spouse of University Employee.
            </h6>
            <Row>
              <Col md={6} xs={12}>
                <FormGroup className="m-2">
                  <Label for="employee">
                    Are you the GJU University Employee/ Ward/ Spouse ?
                  </Label>
                  <Input
                    type="select"
                    name="employee"
                    id="employee"

                    disabled={!isEdit}
                    onChange={(e) => {
                      handleChange(e);

                    }}
                  >
                    <option value="">Select Option</option>
                    <option value="Yes" selected={regDetails.employee == "Yes"}>Yes </option>
                    <option value="No" selected={regDetails.employee == "No"}>No</option>{" "}
                  </Input>
                </FormGroup>
              </Col>
              <hr></hr>
              {regDetails.employee && <>
                <h5 style={{ color: "#413c58" }}>
                  Upload Document{" "}
                  <span style={{ color: "red" }}>(1MB JPG,JPEG,PNG format only)</span>
                </h5>
                <h6 style={{ color: "#0f0f0f" }}>
                  Please note that all the documents should be uploaded in the
                  format as specified on the instructions.
                </h6>
                {documents?.map((doc, index) => (
                  <Col md={6} name="marksheetLabel">
                    <FormGroup className="m-2">
                      <Label for="documentsDto.marksheet">
                        {doc.docName} (1MB JPG,JPEG,PNG ONLY)
                      </Label>
                      <br />
                      {regDetails.docs.filter(d => d.abbr == doc.abbr)?.length > 0 &&
                        <a
                          onClick={() => {
                            toggle();
                            loadProfile(infoData.mobileNumber, doc.abbr);
                          }}
                          style={{ textDecoration: "underline", cursor: "pointer", color: 'black' }}
                        > View Uploaded {viewLabelForAbbr(doc.abbr)} </a>}
                      <Input
                        id={`documentsDto.marksheet${index}`}
                        name="documentsDto.marksheet"
                        type="file"
                        onChange={(e) =>
                          handleChange({
                            target: {
                              name: doc.docName,
                              value: e.target.files[0],
                              type: "document",
                              id: e.target.id,
                            },
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                ))}</>}
            </Row>
          </Form>
          <Form className="text-center">
            <Button color="success" onClick={validateFields}>
              {" "}
              Save{" "}
            </Button>
          </Form>{" "}
        </>
      )}
      <Modal isOpen={modal} toggle={toggle} fullscreen id="Modal2">
        <ModalHeader>View Document</ModalHeader>
        <ModalBody className="text-center">
          {imageBlob && (
            <img width={'100%'} src={URL.createObjectURL(imageBlob)} alt="Fetched Image" />
          )}

        </ModalBody>

      </Modal>
    </Container>
  );
}
